/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, pxToRem, convertHexToRGB, pxToEmWithBaseline, replacePXinStringWithEM, color, textShadow } from 'utils/styles';



/* ++++++++++ --------------- CHECKBOX STYLES --------------- ++++++++++ */
export default {
    checkboxwrapper: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: pxToEm(6),
        // links
        '& a': {
            color: color.white,
            transition: 'color .2s linear 0s',
            '&:hover': {
                color: 'rgba(255,255,255,.7)'
            }
        },
        // input checkbox
        '& .styled-checkbox': {
            fontSize: pxToEm(16),
            cursor: 'pointer',
            position: 'absolute', // take input out of the document flow
            opacity: '0', // then hide it
            zIndex: 2
        },
        // label text
        '& .styled-checkbox + label': {
            fontSize: pxToEm(12),
            cursor: 'text',
            position: 'relative',
            zIndex: 1,
            padding: '0',

            // handle ellipsis (...)
            display: 'flex',
            alignItems: 'center',
            flex: '1',
            minWidth: '0',
            '& .textlabel': {
                color: 'white',
                width: '100%',
                display: 'block',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis'
            }
        },
        // custom box
        '& .styled-checkbox + label:before': {
            content: '" "',
            marginRight: pxToEm(12),
            display: 'inline-block',
            verticalAlign: 'text-top',
            width: pxToEm(22),
            height: pxToEm(20),
            borderColor: color.white,
            borderWidth: pxToEmWithBaseline({ value: 1, fontSizeBaseline: 12 }),
            borderStyle: 'solid',
            borderRadius: pxToEmWithBaseline({ value: 3, fontSizeBaseline: 12 }),
        },
        // validation
        '& .styled-checkbox.valid + label:before': {
            background: 'rgba(0, 0, 0, 0.2)',
            transition: 'background .2s linear 0s'
        },
        '& .styled-checkbox.invalid + label:before': {
            background: convertHexToRGB(color.red, 50),
            transition: 'background .2s linear 0s'
        },
        // custom box hover
        '& .styled-checkbox:hover + label:before': {
            background: 'rgba(0, 0, 0, 0.5)'
        },
        // custom box focus
        '& .styled-checkbox:focus + label:before': {
            boxShadow: replacePXinStringWithEM('0 0 0 3px rgba(0, 0, 0, 0.12)')
        },
        // custom box checked
        '& .styled-checkbox:checked + label:before': {
            background: 'rgba(0, 0, 0, 0.4)'
        },
        // disabled state label
        '& .styled-checkbox:disabled + label': {
            color: '#b8b8b8',
            cursor: 'auto'
        },
        // disabled custom box
        '& .styled-checkbox:disabled + label:before': {
            boxShadow: 'none',
            background: '#ddd'
        },
        // custom checkmark (can also be an image if need be)
        '& .styled-checkbox:checked + label:after': {
            content: '" "',
            position: 'absolute',
            left: pxToEm(5),
            top: pxToEm(9),
            background: 'white',
            width: pxToEm(2),
            height: pxToEm(2),
            boxShadow: replacePXinStringWithEM('2px 0 0 white, 4px 0 0 white, 4px -2px 0 white, 4px -4px 0 white, 4px -6px 0 white, 4px -8px 0 white'),
            transform: 'rotate(45deg)'
        }
        // potential helper https://codepen.io/Vestride/pen/dABHx
    }
};
